<template>
  <div>
    <div id="userSearchFilter">
      <BListFilter
        v-model="form"
        label="Поиск по логину и имени"
        :skeleton="skeleton"
        dense
        @change="onChangeDebounced"
      />
    </div>

    <v-row dense>
      <v-col md :sm="12">
        <BTextFieldAte
          :region.sync="form.region"
          :municipality.sync="form.municipality"
          :school.sync="form.school"
          :skeleton="skeleton"
          model="User"
          style="min-width: 320px;"
          placeholder="Выберите ATE"
          @change="onChangeDebounced"
          @click:clear="onClearAte"
        />
      </v-col>

      <v-col md="auto" :sm="6">
        <BAutocompleteCommon
          v-model="form.timezone"
          $type="timezone"
          :skeleton="skeleton"
          @change="onChangeDebounced"
        />
      </v-col>

      <v-col md="auto" :sm="6">
        <BAutocompleteCommon
          v-model="form.is_active"
          label="Активен?"
          :options="activeOptions"
          item-text="label"
          item-value="value"
          :skeleton="skeleton"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { USER_ACTIVE_OPTIONS } from '../Model'

import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BTextFieldAte from '@/components/forms/BTextFieldAte.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  is_active: null,
  timezone: void 0,
  region: void 0,
  municipality: void 0,
  school: void 0,
})

export default {
  name: 'UsersFilter',
  components: {
    BListFilter,
    BTextFieldAte,
    BAutocompleteCommon,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    activeOptions: Object.values(USER_ACTIVE_OPTIONS),
  }),
  methods: {
    onClearAte() {
      this.form = {
        ...this.form,
        region: void 0,
        municipality: void 0,
        school: void 0,
      }

      this.onChangeDebounced()
    },
  },
}
</script>
